import { Outlet } from "react-router-dom";
const Repos = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};
export default Repos;
